import React from 'react';
import {
  Button,
  Label,
} from 'reactstrap';
import { AvFeedback, AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { ToastContainer, toast } from 'react-toastify';

import Loading from './core/Loading';
import AppComponent from './core/AppComponent';

class Profile extends AppComponent {
  handleValidSubmit = userId => async (e, values) => {
    await this.props.updateProfileQuery({
      variables: {
        userId,
        name: values.name,
        email: values.email,
        phone: values.phone,
      },
    });
    toast.success('Updated Profile!');
  };

  render() {
    const { user } = this.app;
    const { updateProfileQuery } = this.props;

    return (
      <React.Fragment>
        <h2 className="nightingale-text">
          Profile
        </h2>
        <hr />
        <AvForm onValidSubmit={this.handleValidSubmit(user.id)}>
          <AvGroup>
            <Label for="settingsName">Name</Label>
            <AvInput type="text" className="form-control" name="name" aria-describedby="nameHelp" placeholder="Name" defaultValue={user.name} required />
            <AvFeedback color="danger">Please enter a name</AvFeedback>
          </AvGroup>
          <AvGroup>
            <Label for="settingsEmail">Email Address</Label>
            <AvInput type="email" className="form-control" name="email" aria-describedby="emailHelp" placeholder="Email" defaultValue={user.email} required />
            <AvFeedback color="danger">Please enter a valid email address</AvFeedback>
          </AvGroup>
          <AvGroup>
            <Label for="settingsPhone">Phone #</Label>
            <AvInput type="tel" className="form-control" name="phone" placeholder="Phone" defaultValue={user.phone} />
            <AvFeedback color="danger">Please enter a valid phone number</AvFeedback>
          </AvGroup>
          <Button type="submit" color="info">
            {
              updateProfileQuery.loading
                ? <Loading />
                : 'Save'
            }
          </Button>
        </AvForm>
        <ToastContainer />
      </React.Fragment>
    );
  }
}

const UPDATE_PROFILE_QUERY = gql`
mutation UpdateProfile($userId: String!, $email: String!, $name: String!, $phone: String!) {
  updateUser(
    userId: $userId
    email: $email
    name: $name
    phone: $phone
  ) {
    id
  }
}
`;

export default graphql(UPDATE_PROFILE_QUERY, {
  name: 'updateProfileQuery',
})(Profile);



// WEBPACK FOOTER //
// ./src/components/Profile.js